import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    selector: "woa-icon-library",
    templateUrl: "./icon-library.component.html",
    styleUrl: "./icon-library.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconLibraryComponent {
}
